"use client";

import cnBind from "classnames/bind";

import {
    BEAUTY_CAMPAIGN_SAVINGS,
    BEAUTY_CAMPAIGN_STARTER_MONTHLY,
    remainingPlacesOfMax,
    type PublicCampaign,
} from "@/shared/campaign/beautyCampaign";

import styles from "./BeautyCampaignModal.module.scss";

const cx = cnBind.bind(styles);

type Props = {
    open: boolean;
    campaign: PublicCampaign | null;
    loading: boolean;
    onClaim: () => void;
    onBrowse: () => void;
    onClose: () => void;
};

export function BeautyCampaignModal({ open, campaign, loading, onClaim, onBrowse, onClose }: Props) {
    if (!open) return null;

    const remaining = campaign?.remaining;
    const max = campaign?.maxActivations ?? 100;
    const progress =
        campaign && max > 0 ? Math.min(100, Math.round((campaign.activated / max) * 100)) : 0;

    return (
        <div className={cx("overlay")} role="dialog" aria-modal="true" aria-labelledby="beauty100-title">
            <div className={cx("panel")}>
                <button type="button" className={cx("close")} onClick={onClose} aria-label="Закрыть">
                    ×
                </button>
                <p className={cx("label")}>Специальная программа · BEAUTY 100</p>
                <h2 id="beauty100-title" className={cx("title")}>
                    {campaign?.maxActivations ?? 100} Beauty-тенантов
                    <span>TEZAM бесплатно на {campaign?.freeMonths ?? 12} месяцев</span>
                </h2>
                <p className={cx("lead")}>
                    Онлайн-запись, CRM, Telegram Mini App и инструменты для управления Beauty-бизнесом.
                </p>

                <div className={cx("value")}>
                    <div className={cx("old")}>
                        <s>
                            {BEAUTY_CAMPAIGN_STARTER_MONTHLY} BYN / мес
                        </s>
                        <span>{BEAUTY_CAMPAIGN_SAVINGS} BYN / год</span>
                    </div>
                    <div className={cx("now")}>
                        <strong>0 BYN</strong>
                        <span>на 12 месяцев</span>
                    </div>
                </div>

                <div className={cx("availability")}>
                    {loading && remaining == null ? (
                        <p>Проверяем доступность программы…</p>
                    ) : remaining == null ? (
                        <p>Места ограничены — успейте забрать своё</p>
                    ) : (
                        <>
                            <p>{remainingPlacesOfMax(remaining, max)}</p>
                            <div className={cx("bar")} aria-hidden>
                                <span style={{ width: `${progress}%` }} />
                            </div>
                        </>
                    )}
                </div>

                <div className={cx("actions")}>
                    <button type="button" className={cx("primary")} onClick={onClaim}>
                        Забрать бесплатное место
                    </button>
                    <button type="button" className={cx("secondary")} onClick={onBrowse}>
                        Сначала посмотреть Beauty
                    </button>
                </div>

                <p className={cx("micro")}>
                    Без привязки банковской карты. Предложение действует для новых Beauty-бизнесов, пока
                    доступны места.
                </p>
            </div>
        </div>
    );
}
